module.exports = "<div class=\"c-markdown-key\">\n    <h2>Pricing</h2>\n    <p>Each individual pricing rule can have a global pricing change set, which overrides any individual values set on events below. This allows you to create a single group for multiple events with one pricing rule.</p>\n\n    <p>If only the pricing type global is selected, the values can be set individually by event below.</p>\n\n    <p>If neither global values are set you can create custom pricing rules per event on that rule for this period.</p>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/base/views/period.cheatsheet.html
// module id = 389
// module chunks = 0